/**
 * Internal Dependencies
 */
import Icon from './icon';
import controls from './controls';

const blockAdminSettings = {
	color: '#FF6B6B',
	icon: Icon,
	title: 'Welcome Screen',
	controls,
	order: 0,
};

export default blockAdminSettings;
